<template>
    <div>

        <div>
            <v-container>
                <v-row>
                    <v-col cols="12" md="6" class="px-md-0 text-center" style="height: 100%;">
                        <div class="d-block cursor-pointer CSProductName not-text-decoration color-cs-2 gtAmerica-extended" v-html="variations[variationActive].textInCover">
                            
                        </div>
                        <v-img :src="'https://artlesscms.actstudio.xyz/'+cover" class="text-center" :contain="false" height="100%">
                        </v-img>
                        <template v-if="productLink != false">
                            <div class="mt-6">
                                <v-btn :to="'/product/'+productLink" class="btn-product" color="black" outlined tile :ripple="false" :height="alto" :width="ancho">
                                    <span class="tag-btn-shop-now">
                                    Original <span class="bold tag-btn-shop-now"> Product</span>
                                    </span>
                                </v-btn>
                            </div>
                        </template>
                    </v-col>
                    <v-col cols="12" md="6" class="px-md-12 pb-md-1" style="border-left: 2px solid #979797;">

                        <div class="pl-md-12">
                            <div>
                                <span class="CSCategoryTitle uppercase color-cs-1 d-block variation-name">{{product.name}} VARIATIONS</span>
                            </div>

                            <div class="CSVariationsContainer">

                                <template v-for="(variation,v) in variations">

                                    <template v-if="variation.product._id == product._id">
                                        <span class="d-block cursor-pointer CSProductName not-text-decoration color-cs-2 pb-3" :key="'variation-'+v" @click="variationActive = v" v-bind:class="{'bold':variationActive == v}">
                                            {{variation.name}}
                                        </span>
                                    </template>
                                </template>
                            </div>

                            <span id="materials-span" class="gtAmerica-extended-bold d-block mt-6 CSCategoryTitle mb-0">MATERIALS</span>

                            <template v-for="(variation,v) in variations">
                                <transition name="fade-transition" :key="'v-'+v">
                                    <div class="materials-container" v-html="variation.materials" v-show="variationActive == v">
                                    </div>
                                </transition>
                            </template>
                        
                        </div>
                    </v-col>
                </v-row>

            </v-container>
            <template v-if="false">
                <v-container>
                    <v-row>
                        <v-col class="text-right">
                            <router-link :to="'/product/'+productLink" class="csLinkToProduct">
                                Original Product
                            </router-link>
                        </v-col>
                    </v-row>
                </v-container>
            </template>

            <v-container :fluid="screenWidth > 599" class="mt-md-12" >
                <v-row class="my-md-6">
                    <v-col cols="12" class="px-md-0">
                        <div class="owl-carousel-custom owl-carousel-cs" style="position: relative;">
                            <template v-for="(variation,v) in variations">
                                <carousel :autoplay="false" :nav="false" :items="2" :key="'car-'+v" :dots="false" v-if="variationActive == v" :responsive="{0:{items:1},600:{items:2}}">
                                    <template v-for="(image, i) in variation.images">
                                        <img :src="'https://artlesscms.actstudio.xyz/'+image.path" :key="'image-'+i" class="img-cs-carousel"></img>
                                    </template>

                                    <template slot="prev">
                                        <span class="prev-icon"><v-icon size="36" color="#221F1F">mdi-chevron-left</v-icon></span>
                                    </template>

                                    <template slot="next">
                                        <span class="next-icon"><v-icon size="36" color="#221F1F">mdi-chevron-right</v-icon></span>
                                    </template>



                                </carousel>    
                            </template> 
                        </div>
                    </v-col>
                </v-row>
            </v-container>

            <v-container class="pb-12">
                <v-row v-if="screenWidth < 600">
                    <v-col v-for="(category,c) in categories" :key="'category-'+c" cols="6" class="text-center">
                        <router-link :to="'/cs/'+category.url" class="not-text-decoration">
                            <v-img :src="'https://artlesscms.actstudio.xyz/'+category.icon.path" width="200"></v-img>

                            <span class="d-block">{{category.name}}</span>
                        </router-link>
                    </v-col>
                </v-row>
                <v-row justify="center" v-if="screenWidth > 599">
                    <v-col v-for="(category,c) in categories" :key="'category-'+c" cols="auto" class="text-center">
                        <router-link :to="'/cs/'+category.url" class="not-text-decoration">
                            <v-img :src="'https://artlesscms.actstudio.xyz/'+category.icon.path" width="200"></v-img>

                            <span class="d-block">{{category.name}}</span>
                        </router-link>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </div>
</template>

<script>
import carousel from 'vue-owl-carousel'

export default {
    components: { carousel },
    data(){
        return{
            categories:[],
            product:{
                cover:{
                    path: ''
                }
            },
            variations: [],
            variationActive: 0
        }
    },
    computed:{
        isLinked: function(){

            if(this.variations.length > 0){
                if(this.variations[this.variationActive].productLink === 'undefined'){
                    return false
                }else{
                    if(this.variations[this.variationActive].productLink != null){
                        return true
                    }else{
                        return false
                    }
                }
            }else{
                return false
            }

            return false
        },
        cover: function(){
            if(this.variations.length > 0){
                if(this.variations[this.variationActive].cover === 'undefined'){
                    return this.product.cover.path;
                }else{
                    if(this.variations[this.variationActive].cover != null){
                        return this.variations[this.variationActive].cover.path
                    }else{
                        return this.product.cover.path;
                    }
                }
            }else{
                return this.product.cover.path;
            }
        },
        productLink: function(){
            if(this.variations.length > 0){
                if(this.variations[this.variationActive].productLink === 'undefined'){
                    return false
                }else{
                    if(this.variations[this.variationActive].cover != null){
                        return this.variations[this.variationActive].productLink.url
                    }else{
                        return false
                    }
                }
            }else{
                return false
            }
        },
        screenWidth: function(){
            return this.$vuetify.breakpoint.width;
        },
        alto: function () {
            if (this.$vuetify.breakpoint.width >= 2300) {
                if (this.$vuetify.breakpoint.width >= 3500) {
                return 110;
                } else {
                return 110;
                }
            } else {
                if (this.$vuetify.breakpoint.width >= 2300) {
                return 83;
                } else {
                return 55;
                }
            }
            },
            ancho: function () {
            if (this.$vuetify.breakpoint.width >= 2300) {
                if (this.$vuetify.breakpoint.width >= 2300) {
                return 368;
                } else {
                return 368;
                }
            } else {
                if (this.$vuetify.breakpoint.width >= 3500) {
                return 276;
                } else {
                return 184;
                }
            }
        },
    },
    beforeMount: function(){

        var aux = this;
        fetch(
            "https://www.artlesscms.actstudio.xyz/api/collections/get/CSProduct?token=a15be93e9cdb43ca2b3778c2077c26",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                filter: {
                    url: this.$route.params.url
                },
                populate: 1 // resolve linked collection items
                })
            }
        )
        .then(res => res.json())
        .then(res => (this.product = res.entries[0]))
        .then(() => {
            var breadcrumbs = [
                {
                    text: 'CS',
                    link: '/cs',
                    isLink: true
                },
                {
                    text: this.product.name,
                    link: '/materials',
                    isLink: false
                }
            ];
            this.$emit("updateStatus", breadcrumbs);
        })


        fetch(
            "https://www.artlesscms.actstudio.xyz/api/collections/get/CSVariations?token=a15be93e9cdb43ca2b3778c2077c26",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                filter: {
                    active: true
                },
                populate: 1 // resolve linked collection items
                })
            }
        )
        .then(res => res.json())
        .then(res => (this.variations = res.entries))
        .then(() => (this.setActive()))

        fetch('https://www.artlesscms.actstudio.xyz/api/collections/get/CSCategory?token=a15be93e9cdb43ca2b3778c2077c26', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                populate: 0
            })
        })
        .then(res=>res.json())
        .then(res => this.categories = res.entries )
    },
    mounted: function(){
        this.$emit("update", 1);

        var aux = this;
        gtag('config', 'UA-26953667-1', {
            'page_title' : 'Home',
            'page_path': '/CS/product/'+aux.$route.params.url
        });
    },
    methods:{
        setActive: function(){
            var found = false;
            for (let index = 0; index < this.variations.length; index++) {
                if(this.variations[index].product.url == this.$route.params.url){
                    if(!found){
                        this.variationActive = index;
                        found = true;
                    }
                }
                
            }
        }
    },
    watch:{
        variationActive: function(){
            if(this.screenWidth < 600){
                this.$vuetify.goTo('#materials-span');
            }
        }
    }
}
</script>